import React from 'react';

/**
 * The Chatty Book Logo - Text only
 */
export function Logo({ className = "", showText = true, textClassName = "" }) {
  return (
    <div className={`flex items-center ${className}`}>
      <span className={`font-display font-bold tracking-tight whitespace-nowrap ${textClassName}`}>
        <span className="text-ink">The </span>
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-rust to-gold">Chatty</span>
        <span className="text-ink"> Book</span>
      </span>
    </div>
  );
}

/**
 * Compact logo - just the "C" for small spaces
 */
export function LogoIcon({ className = "w-8 h-8" }) {
  return (
    <div className={`flex items-center justify-center font-display font-bold bg-clip-text text-transparent bg-gradient-to-br from-rust to-gold ${className}`}>
      <span className="text-2xl">C</span>
    </div>
  );
}

export default Logo;
